import React from "react";
import s from "./TableRow.less";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import clsx from "clsx";

type TItem = {
  isMoratorium?: string;
  employeeId: string;
  employee: any;
  trainingCode: string;
  level_start: EmployeeTrainingStatus;
  level_base: EmployeeTrainingStatus;
  level_standard: EmployeeTrainingStatus;
  level_cert: EmployeeTrainingStatus;
  level_expert: EmployeeTrainingStatus;
};

interface IProps {
  options: string[];
  item: TItem;
  rowValuesDecorator?: (
    value: any,
    optionName: string,
    dataObject?: any
  ) => any;
}

enum EmployeeTrainingStatus {
  NOT_STARTED = "NOT_STARTED",
  EXPIRED_CERTIFICATION = "EXPIRED_CERTIFICATION",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_FINISHED = "NOT_FINISHED",
  NOT_PROVIDER = "NOT_PROVIDER",
  COMPLETED = "COMPLETED",
}

const resolveStatus = (el: string, t: TFunction) => {
  if (el === EmployeeTrainingStatus.NOT_STARTED)
    return t(`employeeTraining.${EmployeeTrainingStatus.NOT_STARTED}`);
  if (el === EmployeeTrainingStatus.EXPIRED_CERTIFICATION)
    return t(
      `employeeTraining.${EmployeeTrainingStatus.EXPIRED_CERTIFICATION}`
    );
  if (el === EmployeeTrainingStatus.NOT_FINISHED)
    return t(`employeeTraining.${EmployeeTrainingStatus.NOT_FINISHED}`);
  if (el === EmployeeTrainingStatus.IN_PROGRESS)
    return t(`employeeTraining.${EmployeeTrainingStatus.IN_PROGRESS}`);
  if (el === EmployeeTrainingStatus.COMPLETED)
    return t(`employeeTraining.${EmployeeTrainingStatus.COMPLETED}`);
  if (el === EmployeeTrainingStatus.NOT_PROVIDER) return "";
  return el;
};

const EmployeeTableRow = ({ options, item, rowValuesDecorator }: IProps) => {
  const { t } = useTranslation();
  return (
    <tr data-color={item?.isMoratorium ? "isMoratorium" : ""}>
      {options.map((el, id) => {
        return (
          <td
            key={id}
            className={clsx({
              [s.td_no_complete]:
                item[el] === EmployeeTrainingStatus.NOT_STARTED ||
                item[el] === EmployeeTrainingStatus.EXPIRED_CERTIFICATION,
              [s.td_progress]:
                item[el] === EmployeeTrainingStatus.NOT_FINISHED ||
                item[el] === EmployeeTrainingStatus.IN_PROGRESS,
              [s.td_complete]: item[el] === EmployeeTrainingStatus.COMPLETED,
            })}
          >
            {!!rowValuesDecorator
              ? rowValuesDecorator(resolveStatus(item[el], t), el, item)
              : resolveStatus(item[el], t)}
          </td>
        );
      })}
    </tr>
  );
};

export default EmployeeTableRow;
